import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  LoopFieldsSet,
  useFormHandler,
} from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { addJobStart } from "../../../../../redux/slices/leads/leadsSlice";
import { useDispatch, useSelector } from "react-redux";

const JobPost = ({ onClose, data, onSuccess }) => {
  const { user } = useSelector((state) => state?.auth)
  const {loading} = useSelector((state) => state?.leads)
  // const [loading,setLoading] = useState(false);
  const dispatch = useDispatch();
  // const initialFormData = {
  //   website: data.companyId?.website || "",
  //   // jobDescriptionLink: data.description || "",
  //   jobDescriptionLink: "",
  //   // jobTitle: data.title || "",
  //   jobTitle: "",
  // //   jobLocation: data.location
  // // ? `${data.location.city || ""} - ${data.location.state || ""}`
  // // : "",
  // jobLocation: data.location
  // ? {
  //     city: data.location.city || "",
  //     state: data.location.state || "",
  //     country: "US", // default
  //   }
  // : "",


  //   // industry: data.companyId?.[0]?.industry || "",
  //   industry: data.companyId?.industry || "",
  //   postersDetails: [
  //     {
  //       id: uuidv4(),
  //       firstName: "",
  //       lastName: "",
  //       designation: "",
  //       email: "",
  //       phone: "",
  //       contactLocation: "",
  //     },
  //   ],
  // };
  const initialFormData = {
    website: "",
    jobDescriptionLink: "",
    jobTitle: "",
    city: "",
    industry: "",
    postersDetails: [
      {
        id: uuidv4(),
        firstName: "",
        lastName: "",
        designation: "",
        email: "",
        phone: { code: "", number: "" },
        contactLocation: "",
      },
    ],
  };
  const parsePhone = (phone) => {
    if (!phone) return { code: "+91", number: "" };

    if (typeof phone === "object" && phone.code && phone.number) {
      return {
        code: phone.code || "+91",
        number: String(phone.number || ""),
      };
    }

    if (typeof phone === "string") {
      const parts = phone.trim().split(" ");
      return {
        code: parts[0] || "+91",
        number: parts[1] || "",
      };
    }

    return { code: "+1", number: "" };
  };
  const parseLocationPaylaod = (loc) => {
    if (!loc) return { city: "", state: "" };

    // if it's already an object with city/state
    if (typeof loc === "object" && !loc.value) {
      return {
        city: loc.city || "",
        state: loc.state || "",
      };
    }

    // if it's dropdown object { value: "City-State" }
    let raw = "";
    if (typeof loc === "object" && loc.value) raw = String(loc.value);
    else if (typeof loc === "string") raw = loc;
    else return { city: "", state: "" };

    const parts = raw.split(/[-,]/).map((p) => p.trim()).filter(Boolean);

    if (parts.length === 0) return { city: "", state: "" };
    if (parts.length === 1) {
      // per your rule: single value -> treat as state
      return { city: "", state: parts[0] };
    }
    return { city: parts[0] || "", state: parts[1] || "" };
  };
  // const initialFormData = {
  //   website: data.website || data.companyId?.website || "",
  //   jobDescriptionLink: data.jobDescription || "",
  //   jobTitle: { label: data.jobTitle, value: data.jobTitle } || "",

  //   // jobLocation: data.jobLocation
  //   //   ? {
  //   //     city: data.jobLocation.split(",")[0].trim(),
  //   //     state: data.jobLocation.split(",")[1]?.trim() || "",
  //   //     country: "US",
  //   //   }
  //   //   : "",
  //   jobLocation: data.jobLocation
  //     ? Object.fromEntries(
  //         Object.entries({
  //           city: data.jobLocation.split(",")[0]?.trim(),
  //           state: data.jobLocation.split(",")[1]?.trim(),
  //           country: "US",
  //         }).filter(([_, v]) => v)
  //       )
  //     : "",

  //   industry: { label: data.industry, value: data.industry } || "",

  //   postersDetails: data.contactDetails?.length
  //     ? data.contactDetails.map((p) => ({
  //       id: uuidv4(),
  //       uiid: p.uiid,
  //       firstName: p.name?.split(" ")[0] || "",
  //       lastName: p.name?.split(" ")[1] || "",
  //       designation: p.designation || "",
  //       email: p.email || "",
  //       phone: parsePhone(p.phone),
  //       // contactLocation: p.location?.city
  //       //   ? `${p.location.city} - ${p.location.state}`
  //       //   : "",
  //       contactLocation: (() => {
  //         const city = p.location?.city?.trim();
  //         const state = p.location?.state?.trim();
  //         const locationParts = [city, state].filter(Boolean);
  //         const labelValue = locationParts.join(" - ");
  //         return {
  //           value: labelValue,
  //           label: labelValue,
  //         };
  //       })(),
  //     }))
  //     : [
  //       {
  //         id: uuidv4(),
  //         uiid : null,
  //         firstName: "",
  //         lastName: "",
  //         designation: "",
  //         email: "",
  //         phone: "",
  //         contactLocation: "",
  //       },
  //     ],
  // };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      website: { type: "text", required: true },
      jobDescriptionLink: { type: "text", required: true },
      jobTitle: { type: "select", required: true },
      postersDetails: [
        {
          firstName: { type: "text", required: true },
          lastName: { type: "text", required: true },
          designation: { type: "text", required: true },
          email: { type: "email", required: true },
          // phone: { type: "phone", required: true },
          // contactLocation: { type: "select", required: true },
        },
      ],
    });
  const validateJobOnly = () => {
    let hasError = false;

    const newErrors = {};

    if (!formData.website?.trim()) {
      newErrors.website = "Website is required.";
      hasError = true;
    }

    if (!formData.jobDescriptionLink?.trim()) {
      newErrors.jobDescriptionLink = "Job description link is required.";
      hasError = true;
    }

      if (!formData.jobTitle || (typeof formData.jobTitle === "object" && !formData.jobTitle.value)) {
      newErrors.jobTitle = "Job title is required.";
      hasError = true;
    }

    // Validate jobLocation (object with city/state)
    if (
      !formData.jobLocation ||
      !formData.jobLocation.city ||
      !formData.jobLocation.state
    ) {
      newErrors.jobLocation = "Job location is required.";
      hasError = true;
    }

    // if (!formData.industry || (typeof formData.industry === "object" && !formData.industry.value)) {
    //   newErrors.industry = "Industry is required.";
    //   hasError = true;
    // }

    Object.keys(newErrors).forEach((key) => {
      handleChange(key, formData[key]);
    });

    return !hasError;
  };


  const addPostersDetails = () => {
    const newPoster = {
      id: uuidv4(),
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      phone: "",
      contactLocation: "",
    };

    setFormData({
      ...formData,
      postersDetails: [...formData.postersDetails, newPoster],
    });
  };

  const removePosterDetails = (posterId) => {
    if (formData.postersDetails.length > 1) {
      const updatedPosters = formData.postersDetails.filter(
        (poster) => poster.id !== posterId
      );
      setFormData({
        ...formData,
        postersDetails: updatedPosters,
      });
    }
  };

  const parseLocation = (loc) => {
    if (!loc) return null;

    if (typeof loc === "object" && loc.city && loc.state) return loc;

    if (typeof loc === "object" && loc.value) {
      const [cityRaw, stateRaw] = loc.value.split("-").map((p) => p.trim());
      return {
        country: "US",
        city: cityRaw || "",
        state: stateRaw || "",
      };
    }

    if (typeof loc === "string") {
      const [cityRaw, stateRaw] = loc.split("-").map((p) => p.trim());
      return {
        country: "US",
        city: cityRaw || "",
        state: stateRaw || "",
      };
    }

    return null;
  };

  // const parsePhone = (phone) => {
  //   if (!phone) return { code: "+91", number: "" };
  //   const parts = phone.trim().split(" ");
  //   if (parts.length === 2) return { code: parts[0], number: parts[1] };
  //   else return { code: "+91", number: parts[0] };
  // };

  // const handleSaveEducation = () => {
  //   const isValid = validateAllFields();
  //   if (isValid) {
  //     console.log("Add Account details:", formData);
  //   }
  // };

  const handleSaveEducation = () => {
    try {
      const isValid = validateAllFields();
      if (!isValid) return;
      // setLoading(true);
      const jobLocation = parseLocation(formData?.city);

      const jobFields = {
        title: formData.jobTitle?.value ?? formData.jobTitle,
        description: formData.jobDescriptionLink,
        location: jobLocation,
        industry: formData.industry?.value ?? formData.industry,
        website: formData.website,
      };

      // const Prospects = formData.postersDetails.map((poster) => {
      //   const { code, number } = parsePhone(poster?.phone);
      //   return {
      //     firstName: poster?.firstName,
      //     lastName: poster?.lastName,
      //     designation: poster?.designation,
      //     mobile: { code, number },
      //     // email: poster.email,
      //     email : {
      //       email : poster?.email
      //     },
      //     location: parseLocation(poster?.contactLocation),
      //   };
      // });
      const Prospects = formData.postersDetails.map((poster) => {
        const prospect = {
          firstName: poster?.firstName,
          lastName: poster?.lastName,
          designation: poster?.designation,
          // email: poster.email,
          email: {
            email: poster?.email
          },
          location: parseLocation(poster?.contactLocation),
        };

        if (poster.phone?.number) {
          prospect.mobile = {
            code: poster?.phone?.code || "",
            number: Number(poster?.phone?.number),
          };
        }

        return prospect;
      });

      const payload = {
        coll: "Job",
        postActions: ["AddToProspect"],
        payload: {
          ...jobFields,
          addedBy: data?.addedBy,
          status: 2,
          modifiedBy: user?.data?.uiid,
          modifiedOn: new Date(),
          // companyId: data.companyId?.[0]?.uiid,
          // companyId: data?.companyId?.uiid,
          companyId: data?.companyId?.uiid || data?.companyId,
          Prospects,
          role: user?.data?.role?.type
        },
      };
      // console.log("Payload",payload)
      dispatch(
        addJobStart({
          payload,
          onSuccess: () => onSuccess(),
        })
      );
    } catch (error) {
      console.error("Error in handleSaveEducation:", error);
    } finally {
      // setLoading(false);
    }
  };
  // const handleSaveEducation = async () => {
  //   try {
  //     setLoading(true);
  //     const isValid = validateAllFields();
  //     if (!isValid) return;
  //     const seenEmails = new Set();
  //     for (const p of formData.postersDetails) {
  //       const email = (p.email || "").trim().toLowerCase();
  //       if (!email) continue;
  //       if (seenEmails.has(email)) {
  //         showToast(`Duplicate email found: ${email}`, "error");
  //         return;
  //       }
  //       seenEmails.add(email);
  //     }

  //     // const { city: jobCity, state: jobState } = parseLocationPaylaod(formData.jobLocation);
  //     const jobLocation =
  //       typeof formData?.city === "object" && formData?.city.value
  //         ? formData?.city.value
  //         : formData?.city;
  //     // let [city, state] = jobLocation?.split("-");
  //     let city = "";
  //     let state = "";

  //     if (jobLocation) {
  //       const parts = jobLocation.split("-").map(p => p.trim()).filter(Boolean);

  //       if (parts.length === 1) {
  //         state = parts[0];
  //       } else {
  //         city = parts[0] || "";
  //         state = parts[1] || "";
  //       }
  //     }

  //     const jobFieldsPayload = {
  //       website: formData.website || "",
  //       description: formData.jobDescriptionLink || "",
  //       title: formData.jobTitle?.value ?? formData.jobTitle,
  //       // location: { city: jobCity || "", state: jobState || "" },
  //       location: { city, state } || {},
  //       industry: formData.industry?.value ?? formData.industry ?? "",
  //     };

  //     // build prospects payload
  //     const prospectsPayload = formData.postersDetails.map((p) => {
  //       const rawLocation = p.contactLocation;
  //       const { city: ct, state: st } = parseLocationPaylaod(rawLocation);

  //       const original = Array.isArray(data?.contactDetails)
  //         ? data.contactDetails.find((c) => c.uiid === p.uiid)
  //         : null;
  //       const originalEmail = original ? (original.email && typeof original.email === "object" ? original.email.email : original.email) : "";

  //       let uiidToSend = p.uiid || null;
  //       const newEmail = typeof p.email === "object" ? p.email.email : p.email;
  //       if (original && originalEmail.toLowerCase() !== (newEmail || "").toLowerCase()) {
  //         uiidToSend = null;
  //       }
  //       const prospect = {
  //         uiid: uiidToSend,
  //         firstName: p.firstName || "",
  //         lastName: p.lastName || "",
  //         designation: p.designation || "",
  //         email: { email: (p.email?.email ?? p.email ?? "").trim() },
  //         location: { city: ct || "", state: st || "" },
  //       };

  //       if (p.phone?.number && String(p.phone.number).trim() !== "") {
  //         prospect.mobile = {
  //           code: p.phone.code || "",
  //           number: Number(p.phone.number),
  //         };
  //       }

  //       return prospect;
  //     });

  //     if (data?.id) {
  //       const action = {
  //         postActions: ["AddToProspect"],
  //         payload: [{ type: "SET", value: jobFieldsPayload }],
  //         additionalPayload: { Prospects: prospectsPayload,website: formData?.website ,industry: formData?.industry?.value ?? formData.industry },
  //       };

  //       const updatedJob = {
  //         ...data,
  //         website: jobFieldsPayload.website,
  //         jobDescription: jobFieldsPayload.description,
  //         jobTitle: jobFieldsPayload.title,
  //         // jobLocation: `${jobCity || ""}${jobCity && jobState ? "-" : ""}${jobState || ""}`,
  //         jobLocation: formData.city?.value || "",
  //         industry: jobFieldsPayload.industry,
  //         Prospects: prospectsPayload.map((p) => ({
  //           firstName: p.firstName,
  //           lastName: p.lastName,
  //           email: p.email.email,
  //           phone: p.mobile ? `${p.mobile.code} ${p.mobile.number}` : "",
  //           designation: p.designation,
  //           location: p.location,
  //           uiid: p.uiid || null,
  //         })),
  //       };

  //       dispatch(
  //         updateJobDeatilsStart({
  //           uiid: data.id,
  //           payload: action,
  //           onSuccess: () => {
  //             onSuccess && onSuccess();
  //           },
  //         })
  //       );

  //       return;
  //     }

  //     if (!user?.data?.uiid) {
  //       showToast("User ID missing", "error");
  //       return;
  //     }

  //     const payload = {
  //       coll: "Job",
  //       postActions: ["AddToProspect"],
  //       payload: {
  //         ...jobFieldsPayload,
  //         addedBy: user?.data?.uiid,
  //         companyId: resolvedCompanyId,
  //         Prospects: prospectsPayload,
  //       },
  //     };

  //     dispatch(
  //       addJobStart({
  //         payload,
  //         onSuccess: () => {
  //           onClose && onClose();
  //         },
  //       })
  //     );
  //   } catch (err) {
  //     console.error("err", err);
  //     showToast("Failed to save job", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //  const handleSkip = async () => {
  //   try {
  //     if (!validateJobOnly()) {
  //       return;
  //     }

  //     const jobLocation = parseLocation(formData.jobLocation);
  //     const payload = {
  //       coll: "Job",
  //       postActions: [],
  //       payload: {
  //         title: formData.jobTitle?.value ?? formData.jobTitle,
  //         description: formData.jobDescriptionLink,
  //         location: jobLocation,
  //         industry: formData.industry?.value ?? formData.industry,
  //         website: formData.website,
  //         addedBy: user?.data?.uiid,
  //         companyId: data.companyId?.[0]?.uiid || data.companyId?.uiid,
  //       },
  //     };

  //     dispatch(
  //       addJobStart({
  //         payload,
  //         onSuccess: () => {
  //           onClose();
  //         },
  //       })
  //     );
  //   } catch (err) {
  //     console.error("Error in handleSkip:", err);
  //   }
  // };
  useEffect(() => {
    if (data) {
      let cityStateValue = { city: "", state: "" };
      // if (data.jobLocation) {
      //   const parts = data.jobLocation.split(",").map((p) => p.trim());
      //   cityStateValue = { city: parts[0] || "", state: parts[1] || "" };
      // }
      if (data?.jobLocation) {
        const cleanedLocation = data?.jobLocation.trim();
        const withoutCountry = cleanedLocation
          .replace(/\b(US|U\.S\.A\.?|United States|USA)\b/gi, "")
          .replace(/\s*,\s*$/, "")
          .trim();
        if (withoutCountry.includes(" - ")) {
          cityStateValue = withoutCountry;
        } else {
          const parts = withoutCountry
            .split(",")
            .map((p) => p.trim())
            .filter((p) => p && p !== "-");

          cityStateValue = parts.join(" - ");
        }
      }
      // console.log("data.contactDetails",data.contactDetails)
      setFormData({
        website: data?.website || "",
        // jobDescriptionLink: data?.jobDescription || "",
        // jobTitle: { value: data?.jobTitle, label: data?.jobTitle },
        // city: {
        //   // value: `${cityStateValue.city} - ${cityStateValue.state}`,
        //   // label: data.jobLocation,
        //   value: cityStateValue,

        // },
        industry: { value: data?.industry, label: data?.industry },
        // postersDetails: data.contactDetails?.map((contact) => {
        //   const phoneParts = contact.phone?.split(" ") || ["", ""];
        //   // console.log("phoneParts", phoneParts);
        //   // const code = contact.phone?.code || "";
        //   // const number = contact.phone?.number
        //   //   ? String(contact.phone.number)
        //   //   : "";
        //   return {
        //     id: uuidv4(),
        //     firstName: contact.name?.split(" ")[0] || "",
        //     lastName: contact.name?.split(" ")[1] || "",
        //     designation: contact.designation || "",
        //     email: contact.email || "",
        //     phone: { code: phoneParts[0], number: phoneParts[1] },
        //     // phone: { code: phoneParts[0], number: String(phoneParts[1] || "") },
        //     // phone: { code, number },

        //     // contactLocation: {
        //     //   value: `${contact.location.city}-${contact.location.state}`,
        //     //   label: `${contact.location.city}-${contact.location.state}`,
        //     // },
        //     contactLocation: (() => {
        //       const city = contact.location?.city?.trim();
        //       const state = contact.location?.state?.trim();
        //       const locationParts = [city, state].filter(Boolean);

        //       const labelValue = locationParts.join("-");
        //       return {
        //         value: labelValue,
        //         label: labelValue,
        //       };
        //     })(),
        //     uiid: contact.uiid || null,
        //   };
        // }) || [
        //   {
        //     id: uuidv4(),
        //     firstName: "",
        //     lastName: "",
        //     designation: "",
        //     email: "",
        //     phone: { code: "", number: "" },
        //     contactLocation: { value: "", label: "" },
        //   },
        // ],
        postersDetails: data?.contactDetails?.map((contact) => {
          // Handle phone safely
          // let phone = { code: "", number: "" };

          // if (contact.phone && typeof contact.phone === "string" && contact.phone.trim() !== "") {
          //   const phoneParts = contact.phone.split(" ").filter(Boolean);
          //   phone = {
          //     code: phoneParts[0] || "",
          //     number: phoneParts[1] || "",
          //   };
          // }
          let phone = { code: "", number: "" };

          if (contact.phone) {
    if (typeof contact.phone === "string" && contact.phone.trim() !== "") {
              const phoneParts = contact.phone.split(" ").filter(Boolean);
              phone = {
                code: phoneParts[0] || "",
                number: phoneParts[1] || "",
              };
            } else if (typeof contact.phone === "object") {
              phone = {
                code: contact?.phone?.code || "",
                number: contact?.phone?.number || "",
              };
            }
          }
  

          if (!phone.code) phone.code = "";
          if (!phone.number) phone.number = "";
  

          return {
            id: uuidv4(),
            firstName: contact.name?.split(" ")[0] || "",
            lastName: contact.name?.split(" ")[1] || "",
            designation: contact.designation || "",
            email: contact.email || "",
            phone, // only shows if truthy
            contactLocation: (() => {
              const city = contact.location?.city?.trim();
              const state = contact.location?.state?.trim();
              const locationParts = [city, state].filter(Boolean);
              const labelValue = locationParts.join(" - ");
              return {
                value: labelValue,
                label: labelValue,
              };
            })(),
            uiid: contact.uiid || null,
          };
        }) || [
          {
            id: uuidv4(),
            firstName: "",
            lastName: "",
            designation: "",
            email: "",
            phone: { code: "", number: "" },
            contactLocation: { value: "", label: "" },
          },
        ],
  
      });
    }
  }, [data]);
  return (
    <div className="w-full min-h-[70vh] flex flex-col justify-between">
      <div className="flex flex-col gap-5">
        <div>
          <h6>Job Details</h6>
          <div className="w-20 h-0.5 bg-primary"></div>
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-4 gap-4">
          <FormFieldSet
            type="text"
            title="Website"
            placeholder="Enter Website"
            value={formData.website}
            onChange={(value) => handleChange("website", value)}
            error={errors.website}
          />
          <FormFieldSet
            type="text"
            title="Job Description"
            placeholder="Enter Description Link"
            value={formData.jobDescriptionLink}
            onChange={(value) => handleChange("jobDescriptionLink", value)}
            error={errors.jobDescriptionLink}
          />
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-4 gap-4">
          <FormFieldSet
            // type="jobTitle"
            type="atsJobTitle"
            title="Job Title"
            placeholder="Select Job Title"
            options={[]}
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showButton
            showSearch
          />
          <FormFieldSet
            type="atscitiesState"
            title="Job Location"
            placeholder="Select Job Location"
            showSearch
            parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
            // value={`${formData.jobLocation.city} - ${formData.jobLocation.state}`}
            value={formData.city}
            onChange={(value) => {
              // handleChange("jobLocation", value)
              handleChange("city", value)
            }}
            error={errors.jobLocation}
          />
          <FormFieldSet
            type="industry"
            title="Select Industry"
            placeholder="Select Industry"
            options={[]}
            showButton
            showSearch
            value={formData.industry}
            onChange={(value) => handleChange("industry", value)}
            error={errors.industry}
          />
        </div>
        <LoopFieldsSet
          title="Job Posters Details"
          titleConfig={{ tag: "h6" }}
          addButtonTitle="Add More Contactcs"
          data={formData.postersDetails}
          onAdd={addPostersDetails}
          onRemove={removePosterDetails}
          gridCols="grid-cols-[repeat(6,1fr)_30px]"
          maxItems={5}
          renderFields={(poster, index) => (
            <>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="First Name"
                  placeholder="Enter First Name"
                  value={poster.firstName || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].firstName`, value)
                  }
                  error={errors.postersDetails?.[index]?.firstName}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Last Name"
                  placeholder="Enter Last Name"
                  value={poster.lastName || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].lastName`, value)
                  }
                  error={errors.postersDetails?.[index]?.lastName}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Designation"
                  placeholder="Enter Designation"
                  value={poster.designation || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].designation`, value)
                  }
                  error={errors.postersDetails?.[index]?.designation}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Email Id"
                  placeholder="Enter Email Id"
                  value={poster.email || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].email`, value)
                  }
                  error={errors.postersDetails?.[index]?.email}
                />
              </div>
              {/* <FormFieldSet
                  // type="text"
                  type="phoneNew"
                  title="Phone"
                  placeholder="Enter Phone"
                  // values={poster.phone || ""}
                  values={[poster.phone]}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].phone`, value[0])
                  }
                  error={errors.postersDetails?.[index]?.phone}
                /> */}
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="phone"
                  title="Phone"
                  placeholder="Enter Mobile Number"
                  value={poster.phone?.number || ""}
                  code={poster.phone?.code || ""}
                  onChange={(fullValue, details) =>
                    handleChange(`postersDetails[${index}].phone`, {
                      code: details.countryCode,
                      number: details.number,
                    })
                  }
                  error={errors.postersDetails?.[index]?.phone}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="citiesState"
                  title="Contact Location"
                  placeholder="Select Contact Location"
                  options={[]}
                  value={poster.contactLocation || ""}
                  onChange={(value) =>
                    handleChange(
                      `postersDetails[${index}].contactLocation`,
                      value,
                    )
                  }
                  showSearch
                  parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                  error={errors.postersDetails?.[index]?.contactLocation}
                />
              </div>
            </>
          )}
        />
      </div>
      <div className="flex gap-2 justify-end">
        <Button title={"Cancel"} variant="outlined" onClick={onClose} />
        <Button title={"Save"} onClick={handleSaveEducation} disabled={loading} />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default JobPost;
